import React from 'react';
import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';

import { ReactComponent as CreateIcon } from 'assets/images/create.svg';

type StyledButtonProps = {
  fontSize?: string;
} & ButtonProps;

export default function CreateButton({ ...props }: StyledButtonProps) {
  const StyledComponent = styled(Button)<ButtonProps>(({ theme }) => ({
    borderRadius: '1px',
    textTransform: 'none',
    color: theme.palette?.primary.contrastText,
    border: 'unset',
    background: theme.palette?.primary.main,
    boxShadow: 'none',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '-0.2px',
    zIndex: 2,
    minWidth: '225px',
    minHeight: '42px',
    padding: '6px 16px',
    justifyContent: 'space-between',

    '&:hover': {
      color: theme.palette?.primary.contrastText,
      borderColor: 'rgba(0, 0, 0, 0.25)',
      boxShadow: 'none',
      background: theme.palette?.primary.main,
    },
    '&::after': {
      borderColor: 'none',
      boxShadow: 'none',
      background: theme.palette?.primary.main,
    },
    '& svg': {
      width: '17px',
      height: '17px',
      marginRight: '-4px',
      marginTop: '-4px',
      path: {
        fill: theme.palette?.primary.contrastText,
      },
    },
    '&:disabled': {
      color: '#D0D3D6',
      background: 'transparent',
      border: '1px solid #D0D3D6',
      borderRadius: '1px',
    },
  }));

  return (
    <StyledComponent {...props}>
      {props.children}
      <CreateIcon />
    </StyledComponent>
  );
}
